import ProductModalController from "@/components/ProductModalController";

export default class RedirectModal {
    init() {
        this.productsModalWrapper = document.querySelector('.js-product-modal-wrapper');


        this.triggerPopup();
    }

    triggerPopup() {
        if (this.productsModalWrapper) {

            let productModalController = new ProductModalController();
            productModalController.showModal();
        }
    }
}
